import $ from 'jquery';
import { SVGPosition } from './Class/SVGPosition';

const OME_COLUMN_DESCRIPTIVE_CONTAINER_SELECTOR = '.module-container.one-column-descriptive';

$(OME_COLUMN_DESCRIPTIVE_CONTAINER_SELECTOR).each(function () {
	// eslint-disable-next-line no-new
	new SVGPosition(this);
});
